var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 32,
    viewBox: "0 0 44 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4598 0.544014C30.5788 0.544014 37.2488 6.54701 38.3758 14.344H43.1598L35.1098 23.544L27.0598 14.344H32.3958C31.8813 12.0926 30.6186 10.0821 28.814 8.64086C27.0093 7.19965 24.7693 6.41288 22.4598 6.40902C19.1248 6.40902 16.1808 8.04202 14.3178 10.503L10.3848 6.01801C11.8902 4.2966 13.7467 2.91743 15.8295 1.97324C17.9123 1.02904 20.173 0.541716 22.4598 0.544014ZM21.5398 31.456C13.4438 31.456 6.75084 25.453 5.62384 17.656H0.839844L8.88984 8.45601C11.5808 11.515 14.2488 14.597 16.9398 17.656H11.6038C12.1184 19.9075 13.3811 21.918 15.1857 23.3592C16.9904 24.8004 19.2303 25.5872 21.5398 25.591C24.8748 25.591 27.8188 23.958 29.6818 21.497L33.6148 25.982C32.1109 27.7052 30.2547 29.0856 28.1716 30.0299C26.0885 30.9742 23.827 31.4606 21.5398 31.456Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshWhite);
export default __webpack_public_path__ + "static/media/refresh-white.1a79f13ae995ea7abd08d45563cc3d0f.svg";
export { ForwardRef as ReactComponent };